import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from '../../app-routing.module';

import { SharedModule } from '../shared/shared.module';

import { FormsModule } from '@angular/forms';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMaskModule } from 'ngx-mask';
import { DragulaModule } from 'ng2-dragula';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { ReportComponent } from './report.component';
import { MenuComponent } from './menu/menu.component';
import { DetailComponent } from './detail/detail.component';
import { ReportDataComponent } from './report-data/report-data.component';
import { FilterDateRangeComponent } from './filter-date-range/filter-date-range.component';
import { DetailPurchaseComponent } from './detail-purchase/detail-purchase.component';
import { DetailLocationComponent } from './detail-location/detail-location.component';
import { DetailUserComponent } from './detail-user/detail-user.component';
import { DetailTransactionComponent } from './detail-transaction/detail-transaction.component';
import { DetailAccountComponent } from './detail-account/detail-account.component';
import { DetailDynamicComponent } from './detail-dynamic/detail-dynamic.component';
import { DetailReportComponent } from './detail-report/detail-report.component';
import { DetailCustomerComponent } from './detail-customer/detail-customer.component';
import { DetailBatchComponent } from './detail-batch/detail-batch.component';
import { DetailInventoryComponent } from './detail-inventory/detail-inventory.component';
import { DetailDiscountComponent } from './detail-discount/detail-discount.component';
import { DetailTaxComponent } from './detail-tax/detail-tax.component';
import { DetailPermissionComponent } from './detail-permission/detail-permission.component';
// import { ConversationComponent } from './conversation/conversation.component';
import { ConversationsComponent } from './conversations/conversations.component';
import { DetailGroupComponent } from './detail-group/detail-group.component';
import { DetailEmployeeComponent } from './detail-employee/detail-employee.component';
import { DetailTerminalComponent } from './detail-terminal/detail-terminal.component';
import { DetailPermissionGroupComponent } from './detail-permission-group/detail-permission-group.component';
import { DetailVendorInventoryComponent } from './detail-vendor-inventory/detail-vendor-inventory.component';
import { DetailVendorComponent } from './detail-vendor/detail-vendor.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { DetailMenuActionComponent } from './detail-menu-action/detail-menu-action.component';
import { PurchaseTypeEditorComponent } from './purchase-type-editor/purchase-type-editor.component';
import { ReceiptTemplateEditorComponent } from './receipt-template-editor/receipt-template-editor.component';
import { RegisterPrintEditorComponent } from './register-print-editor/register-print-editor.component';
import { CustomerMergeComponent } from './customer-merge/customer-merge.component';
import { DiscountFilterComponent } from './detail-discount/discount-filter/discount-filter.component';
import { DiscountAdvancedComponent } from './detail-discount/discount-advanced/discount-advanced.component';
import { DiscountSalePriceComponent } from './detail-discount-group/discount-sale-price/discount-sale-price.component';
import { SaleItemComponent } from './detail-discount-group/discount-sale-price/sale-item/sale-item.component';
import { DetailDiscountGroupComponent } from './detail-discount-group/detail-discount-group.component';
import { DiscountItemListComponent } from './detail-discount-group/discount-sale-price/discount-item-list/discount-item-list.component';
import { DiscountGroupCategoryComponent } from './detail-discount-group/discount-sale-price/discount-group-category/discount-group-category.component';
import { ListBuilderComponent } from './list-builder/list-builder.component';
import { DiscountWizardComponent } from './discount-wizard/discount-wizard.component';
import { DetailUserAuthorizationComponent } from './detail-user-authorization/detail-user-authorization.component';
import { DetailUserGroupComponent } from './detail-user-group/detail-user-group.component';
import { DetailReturnTypeComponent } from './detail-return-type/detail-return-type.component';
import { DetailInventoryBasicComponent } from './detail-inventory-basic/detail-inventory-basic.component';
import { DetailBillingAccountComponent } from './detail-billing-account/detail-billing-account.component';
import { DetailInvoiceComponent } from './detail-invoice/detail-invoice.component';
import { DetailViewComponent } from './detail-view/detail-view.component';
import { DetailViewListComponent } from './detail-view-list/detail-view-list.component';
import { InventoryOptionsComponent } from './inventory-options/inventory-options.component';
import { CorrectionDialogComponent } from './correction-dialog/correction-dialog.component';
import { RecordPaymentDialogComponent } from './record-payment-dialog/record-payment-dialog.component';
import { CorrectionListComponent } from './correction-list/correction-list.component';
import { InventoryVendorPricingComponent } from './inventory-vendor-pricing/inventory-vendor-pricing.component';
import { InventoryLocationPricingComponent } from './inventory-location-pricing/inventory-location-pricing.component';
import { VendorLocationGridComponent } from './vendor-location-grid/vendor-location-grid.component';
import { DistributorManagementComponent } from './distributor-management/distributor-management.component';
import { NgChartsModule } from 'ng2-charts';
import { ReportChartComponent } from './report-chart/report-chart.component';
import { ProductOverviewComponent } from './product-overview/product-overview.component';

@NgModule({
  declarations: [
    MenuComponent,
    DetailComponent,
    ReportComponent,
    ReportDataComponent,
    FilterDateRangeComponent,
    DetailPurchaseComponent,
    DetailLocationComponent,
    DetailUserComponent,
    DetailTransactionComponent,
    DetailAccountComponent,
    DetailDynamicComponent,
    DetailReportComponent,
    DetailCustomerComponent,
    DetailBatchComponent,
    DetailInventoryComponent,
    DetailDiscountComponent,
    DetailTaxComponent,
    DetailPermissionComponent,
    ConversationsComponent,
    DetailGroupComponent,
    DetailEmployeeComponent,
    DetailTerminalComponent,
    DetailPermissionGroupComponent,
    DetailVendorInventoryComponent,
    DetailVendorComponent,
    DetailMenuActionComponent,
    PurchaseTypeEditorComponent,
    ReceiptTemplateEditorComponent,
    RegisterPrintEditorComponent,
    CustomerMergeComponent,
    DiscountFilterComponent,
    DiscountAdvancedComponent,
    DiscountSalePriceComponent,
    SaleItemComponent,
    DetailDiscountGroupComponent,
    DiscountItemListComponent,
    DiscountGroupCategoryComponent,
    ListBuilderComponent,
    DiscountWizardComponent,
    DetailUserAuthorizationComponent,
    DetailUserGroupComponent,
    DetailReturnTypeComponent,
    DetailInventoryBasicComponent,
    DetailBillingAccountComponent,
    DetailInvoiceComponent,
    DetailViewComponent,
    DetailViewListComponent,
    InventoryOptionsComponent,
    CorrectionDialogComponent,
    RecordPaymentDialogComponent,
    CorrectionListComponent,
    InventoryVendorPricingComponent,
    InventoryLocationPricingComponent,
    VendorLocationGridComponent,
    DistributorManagementComponent,
    ProductOverviewComponent,
    ReportChartComponent,
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    SharedModule,
    FormsModule,
    NgxDaterangepickerMd.forRoot(),
    NgxMaskModule.forRoot(),
    DragulaModule.forRoot(),
    ColorPickerModule,
    DragDropModule,
    NgChartsModule
  ]
})
export class ReportModule { }
